<div class="integrations-container banner-wrapper" [ngClass]="{ hidden: isIntegrationsBannerDismissed }">
  <div class="integrations-banner">
    <mat-icon class="close-icon" (click)="dismissBanner()">close</mat-icon>
    <div class="integrations-content">
      <div class="banner-text-section">
        <div class="banner-heading">
          {{ 'INTEGRATION_BANNER.BANNER_HEADER' | translate }}
        </div>
        <div class="banner-body">
          {{ 'INTEGRATION_BANNER.BANNER_DESCRIPTION' | translate }}
        </div>
      </div>
      <div class="icons">
        <img [src]="jobberLogo" alt="Jobber Logo" />
        <img [src]="housecallproLogo" alt="Housecall Pro Logo" />
        <img [src]="petResortProLogo" alt="PetResort Pro Logo" />
      </div>
    </div>
    <div class="integrations-button">
      <button mat-flat-button color="primary" class="integrations-button-browse" (click)="navigateToBrowseButton()">
        {{ 'INTEGRATION_BANNER.NAVIGATE_TO_BROWSE_BUTTON' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        class="integrations-button-browse-mobile"
        (click)="navigateToBrowseButton()"
      >
        {{ 'INTEGRATION_BANNER.NAVIGATE_TO_BROWSE' | translate }}
      </button>
    </div>
  </div>
</div>
